import styled from 'styled-components';

export const Container = styled.div`
  min-height: 0;

  .form-group {
    margin-bottom: 1.25rem;
  }

  label {
    color: ${(props) => props.theme.$dark};
    font-weight: 600;
    margin-bottom: 0.35rem;
  }

  .task-section-title {
    color: ${(props) => props.theme.$dark};
    font-weight: 600;
    margin-top: 1.75rem;
    margin-bottom: 0.5rem;
  }

  .task-detail-body {
    overflow-y: auto;
  }

  .task-detail-footer {
    position: sticky;
    bottom: 0;
    background: ${(props) => props.theme.$white};
  }

  .task-note {
    background: ${(props) => props.theme.$gray100};
  }

  .task-note-delete {
    color: ${(props) => props.theme.$danger};
    font-size: 12px;
  }

  .task-note-author {
    color: ${(props) => props.theme.$dark_slate_blue};
    min-width: 0;
  }

  .task-attachment-actions .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .table th,
  .table td {
    padding: 0.85rem 0.75rem;
  }

  .material-icons {
    font-size: 16px;
  }

  .notes-input-group .material-icons {
    font-size: 24px;
  }
`;
